export enum ConsentDeliveryState {
  Pending = 'Pending',
  Failed = 'Failed',
  Delivered = 'Delivered',
  ManuallyChecked = 'ManuallyChecked',
  PendingAfterTransfer = 'PendingAfterTransfer',
}
